<template>
  <div class="protal-register">
    <!-- 右边表单 -->
    <div class="register-content forget-password">
      <div class="content-middle">

        <el-tooltip class="item"
                    effect="dark"
                    placement="right">
          <div slot="content"
               v-if="IAMOnline === '1'">{{$t('validate.isPasswordIam')}}</div>
          <div slot="content"
               v-else>{{$t('validate.isPassword')}}</div>
          <svg data-v-511f72fd=""
               aria-hidden="true"
               class="icon-svg">
            <use data-v-511f72fd=""
                 xlink:href="#icon-info-circle"></use>
          </svg>
        </el-tooltip>
        <!-- 新平台 -->
        <div class="big-title">
          {{ $t('protaForgetPassword.title') }}
        </div>
        <!-- 新密码表单 -->
        <el-form autocomplete="off"
                 class="register-form"
                 :model="dataForm"
                 :rules="dataRule"
                 ref="dataForm"
                 label-position="left"
                 label-width="100px">
          <input class="hide-input"
                 type="password"
                 name="password" />
          <el-form-item prop="mobileOrEmail"
                        class="form-content"
                        :label="$t('protaForgetPassword.phoneLabel')">
            <el-input :placeholder="$t('protaForgetPassword.phonePlace')"
                      type="text"
                      v-model="dataForm.mobileOrEmail"></el-input>
          </el-form-item>
          <el-form-item prop="captcha"
                        class="form-content"
                        :label="$t('protaForgetPassword.captchaPlace')">
            <el-input :placeholder="$t('protaForgetPassword.captchaPlace')"
                      v-model="dataForm.captcha"
                      maxlength="6"
                      id="input-test"
                      type="text"></el-input>
            <div class="get-captcha"
                 :class="captchaDisable? 'captcha-disable':''"
                 @click="phoneCaptchaCheck(60,$event)">{{$t('protaLogin.getCaptcha')}}</div>
          </el-form-item>
          <el-form-item prop="newPassword"
                        class="form-content"
                        :label="$t('protaForgetPassword.passwordLabel')"
                        :rules="IAMOnline === '1' ? dataRule.newPasswordIam : dataRule.newPassword">
            <el-input :placeholder="$t('protaForgetPassword.passwordPlace')"
                      type="password"
                      maxlength="20"
                      v-model="dataForm.newPassword"></el-input>
          </el-form-item>
          <el-form-item prop="passwordSure"
                        class="form-content"
                        :label="$t('protaForgetPassword.passwordSureLabel')"
                        :rules="IAMOnline === '1' ? dataRule.passwordSureIam : dataRule.passwordSure">
            <el-input :placeholder="$t('protaForgetPassword.passwordSurePlace')"
                      type="password"
                      maxlength="20"
                      v-model="dataForm.passwordSure"></el-input>
          </el-form-item>
          <!-- <div class="password3">建议新密码不要与最近使用的三次密码重复</div> -->
          <div class="register-btn"
               @click="dataFormSubmitHandle()">
            <span>{{ $t('protaForgetPassword.sureBtn') }}</span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import { isMobile, isEmail } from '@/utils/validate'

export default {
  components: {
  },
  data() {
    return {
      tabIndex: 0,
      captchaPath: '',
      dataForm: {
        username: '',
        email: '',
        mobileOrEmail: '',
        newPassword: '',
        passwordSure: '',
        captcha: ''
      },
      captchaDisable: false,
      IAMOnline: '0' // IAM是否上线（1上线 0不上线）
    }
  },
  created() {
    this.$request.get('/sys/config/sysConfigList').then((res, total, code, data) => {
      for (let i = 0; i < res.length; i++) {
        if (res[i].paramKey === 'IAM_ONLINE') {
          this.IAMOnline = res[i].paramValue
        }
      }
    }).catch(() => { })
  },
  computed: {
    dataRule() {
      let passwordSame = (rule, value, callback) => {
        if (this.dataForm.newPassword !== this.dataForm.passwordSure) {
          return callback(new Error(this.$t('updatePassword.validate.comfirmPassword')))
        }
        callback()
      }
      let mobileOrEmail = (rule, value, callback) => {
        if (!isMobile(this.dataForm.mobileOrEmail) && !isEmail(this.dataForm.mobileOrEmail)) {
          return callback(new Error(this.$t('protaForgetPassword.mobileOrEmail')))
        }
        callback()
      }
      return {
        mobileOrEmail: [
          { validator: mobileOrEmail, trigger: 'blur' },
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        newPassword: [
          { validator: this.$validate.isPassword, trigger: 'blur' },
          { required: true, message: this.$t('protaForgetPassword.newPasswordLabel1'), trigger: 'blur' }
        ],
        passwordSure: [
          { validator: passwordSame, trigger: 'blur' },
          { validator: this.$validate.isPassword, trigger: 'blur' },
          { required: true, message: this.$t('protaForgetPassword.enterNewPasswordLabel1'), trigger: 'blur' }
        ],
        newPasswordIam: [
          { validator: this.$validate.isPasswordIam, trigger: 'blur' },
          { required: true, message: this.$t('protaForgetPassword.newPasswordLabel1'), trigger: 'blur' }
        ],
        passwordSureIam: [
          { required: true, message: this.$t('protaForgetPassword.enterNewPasswordLabel1'), trigger: 'blur' },
          { validator: this.$validate.isPasswordIam, trigger: 'blur' },
          { validator: passwordSame, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    changeTab(index) {
      this.tabIndex = index
    },
    /**
     * 获取验证码方法
     * @param e 当前点击的element
     */
    // phoneCaptchaCheck(time, e) {
    phoneCaptchaCheck: debounce(function (time, e) {
      if (this.captchaDisable) {
        return false
      }
      if (!isMobile(this.dataForm.mobileOrEmail) && !isEmail(this.dataForm.mobileOrEmail)) {
        this.$alert(this.$t('protaForgetPassword.mobileOrEmail'))
        return false
      } else {
        this.captchaDisable = true
        this.getPhoneCaptcha(time, e)
      }
    }, 1000, { 'leading': true, 'trailing': false }),
    /**
     * 获取验证码
     * @param e 当前点击的element
     */
    // getPhoneCaptcha: debounce(function (time, e) {
    getPhoneCaptcha(time, e) {
      let _this = this
      if (time === 0) {
        this.captchaDisable = false
        e.target.innerHTML = _this.$t('protaLogin.getCaptcha')
      } else {
        if (time === 60) {
          if (isEmail(this.dataForm.mobileOrEmail)) {

            this.$request.post('/auth/sendIamVerifyCode', {
              //email: this.dataForm.mobileOrEmail
              'mobile': this.dataForm.mobileOrEmail,
              'which': 'login',
              'display': 'pc'
            }).then((res, total, code, data) => {

            }).catch(() => {
            })
            // this.$alert(this.$t('protaLogin.captchaEmailSucc'))
            // 按钮不可用
            this.captchaDisable = true
            e.target.innerHTML = time + _this.$t('protaLogin.getCaptchaTip')
            time--
            setTimeout(function () {
              _this.getPhoneCaptcha(time, e)
            }, 1000)
          }
          if (isMobile(this.dataForm.mobileOrEmail)) {
            this.$request.post('/auth/sendIamVerifyCode', { ///sys/sendSms', {
              'mobile': this.dataForm.mobileOrEmail,
              'which': 'login',
              'display': 'pc'
            }).then((res, total, code, data) => {
            }).catch(() => { })
            // this.$alert(this.$t('protaLogin.captchaSucc'))
            // 按钮不可用
            this.captchaDisable = true
            e.target.innerHTML = time + _this.$t('protaLogin.getCaptchaTip')
            time--
            setTimeout(function () {
              _this.getPhoneCaptcha(time, e)
            }, 1000)
          }
        } else {
          this.captchaDisable = true
          e.target.innerHTML = time + _this.$t('protaLogin.getCaptchaTip')
          time--
          setTimeout(function () {
            _this.getPhoneCaptcha(time, e)
          }, 1000)
        }
      }
    },
    // 1000, { 'leading': true, 'trailing': false }),
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.post('/auth/forgetIamPassWord', // this.$request.post('/sys/commuser/forgetPassword',
          this.dataForm
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.$router.replace({ name: 'protalMain' })
            }
          })
        }).catch(() => { })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang="scss" scoped>
.protal-register {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  .captcha-disable {
    color: #aaa;
  }
  .el-form-item {
    width: auto !important;
    margin-bottom: 25px !important;
  }
  input {
    background: none;
  }
  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    font-size: 14px;
    color: #aaa;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-size: 14px;
    color: #aaa;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-size: 14px;
    color: #aaa;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-size: 14px;
    color: #aaa;
  }
  input::-webkit-input-placeholder {
    color: #aaa !important;
  }
  input:-ms-input-placeholder {
    color: #aaa !important;
  }
  .register-content {
    position: relative;
    .hide-input {
      width: 0;
      border: none;
      height: 0;
      padding: 0;
    }
    .bmw-logo {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 64px;
      height: 70px;
      box-shadow: 0 0 10px #ccc;
      background-image: url("../../assets/img/protal/bmw-logo.png");
      background-size: 100%;
    }
    .content-middle {
      width: 360px;
      margin: 0 auto;
      position: relative;
      .item {
        position: absolute;
        right: 10px;
        bottom: 175px;
        z-index: 999;
      }
      .big-title {
        margin-top: 60px;
        line-height: 40px;
        font-size: 24px;
        color: #1b69d4;
      }
      #input-test {
        width: 160px;
      }
      .register-form {
        margin-top: 41px;
        margin-bottom: 20px;
        .form-content {
          position: relative;
          border-bottom: 1px solid #ccc;
          label {
            display: inline-block;
            width: 90px;
            color: #262626;
            font-size: 15px;
            margin-top: 13px;
          }
          input {
            width: 240px;
            height: 49px;
            margin-left: 10px;
            font-size: 14px;
            color: #262626;
            border: none !important;
          }
          input:focus {
            border: none !important;
            outline: none !important;
          }
          .captcha {
            cursor: pointer;
            display: flex;
            width: 100px;
            height: 50px;
            position: absolute;
            top: 0;
            right: 0;
            align-items: center;
            img {
              width: 100px;
            }
          }
        }
        .register-bar {
          display: flex;
          margin-top: 20px;
          margin-bottom: 40px;
          justify-content: space-between;
          .find-password {
            color: #1b69d4;
          }
          span {
            color: #1b69d4;
          }
        }
      }
      .register-btn {
        display: flex;
        cursor: pointer;
        margin-top: 38px;
        width: 360px;
        height: 45px;
        font-size: 18px;
        color: #ffffff;
        align-items: center;
        justify-content: center;
        background: #1b69d4 100%;
      }
      .regist-btn {
        background: #262626 100%;
      }
      .get-captcha {
        position: absolute;
        cursor: pointer;
        right: 1px;
        border: none;
        bottom: 10px;
      }
    }
    .icon-svg {
      cursor: pointer;
    }
  }
}
.password3 {
  text-align: center;
  color: red;
}
</style>
